import React from 'react';
import Image from '../../../components/AppImage';
import { Phone, MessageCircle, Navigation } from 'lucide-react';

const HeroSection = ({ language }) => {
  const content = {
    de: {
      headline: "Moderne Schnitte • Bartstyling • Klassische Rasuren",
      subline: "Präzise Schnitte. Saubere Fades. Scharfe Bärte.",
      callButton: "Jetzt anrufen",
      whatsappButton: "WhatsApp",
      locationButton: "Wegbeschreibung"
    },
    en: {
      headline: "Modern Cuts • Beard Styling • Classic Shaves", 
      subline: "Precise cuts. Clean fades. Sharp beards.",
      callButton: "Call Now",
      whatsappButton: "WhatsApp",
      locationButton: "Directions"
    }
  };

  const handleCall = () => {
    window.location.href = 'tel:+491726060056';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/491726060056', '_blank');
  };

  const handleLocation = () => {
    const element = document.querySelector('#location');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen bg-primary text-white flex items-center justify-center relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/20 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <div className="mb-12">
          <Image
            src="/assets/images/e75f4f8f-2e2c-47d5-8be6-070fec062583-1755963588204.jpeg"
            alt="RWAN CUT Logo"
            className="w-32 h-32 mx-auto rounded-full object-cover shadow-luxury-lg ring-4 ring-secondary/30"
          />
        </div>

        {/* Headlines */}
        <div className="mb-12">
          <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-secondary mb-6 leading-tight">
            {content?.[language]?.headline}
          </h1>
          <p className="font-body text-lg sm:text-xl lg:text-2xl text-white/90 max-w-2xl mx-auto">
            {content?.[language]?.subline}
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <button
            onClick={handleCall}
            className="w-full sm:w-auto bg-secondary text-primary hover:bg-secondary/90 font-body font-semibold px-8 py-4 rounded-lg transition-luxury flex items-center justify-center space-x-2 shadow-luxury"
          >
            <Phone size={20} />
            <span>{content?.[language]?.callButton}</span>
          </button>
          
          <button
            onClick={handleWhatsApp}
            className="w-full sm:w-auto border-2 border-secondary text-secondary hover:bg-secondary hover:text-primary font-body font-semibold px-8 py-4 rounded-lg transition-luxury flex items-center justify-center space-x-2"
          >
            <MessageCircle size={20} />
            <span>{content?.[language]?.whatsappButton}</span>
          </button>
          
          <button
            onClick={handleLocation}
            className="w-full sm:w-auto text-white hover:text-secondary font-body font-semibold px-8 py-4 rounded-lg transition-luxury flex items-center justify-center space-x-2"
          >
            <Navigation size={20} />
            <span>{content?.[language]?.locationButton}</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;